import styles from '@features/homepage/sections/Header/HeaderSection.styles';
import { IHeaderObject } from '@features/cms/typescript';
import SliderItem from '@components/Slider/SliderItem';
import HeaderSlider from '@features/voxbox/sections/Header/components/HeaderSlider/HeaderSlider';
import { ISliderItemImage, TSliderItemMediaType } from '@components/typescript';
type PropsType = {
  header: IHeaderObject;
  isFirst?: boolean;
};
const HeaderSection = ({
  header,
  isFirst = false
}: PropsType) => {
  const isImageType = (item: TSliderItemMediaType): item is ISliderItemImage => (item as ISliderItemImage).type === 'image';
  const getBgContainer = (): string | null => {
    if (header.slides.length && isImageType(header.slides[0]) && header.slides[0]?.blur?.mobile) {
      return typeof header.slides[0].blur.mobile === 'string' ? header.slides[0].blur.mobile : header.slides[0].blur.mobile.path;
    }
    return null;
  };
  return <section sx={styles.section(getBgContainer())} data-testid="HeaderSection">
      {header.slides.length > 1 ? <HeaderSlider slides={header.slides} isFirst={isFirst} /> : <SliderItem item={header.slides[0]} isActive isFirst={!!isFirst} />}
    </section>;
};
export default HeaderSection;